import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWorldPin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 165 136",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		filter: "url(#filter0_d_25_770)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M82.5 120.229C110.091 120.229 132.458 97.8621 132.458 70.2708C132.458 42.6796 110.091 20.3125 82.5 20.3125C54.9088 20.3125 32.5417 42.6796 32.5417 70.2708C32.5417 97.8621 54.9088 120.229 82.5 120.229Z",
				fill: "#DAF6F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M32.5417 70.2708C32.5351 77.3484 34.0364 84.3463 36.9457 90.7983C39.855 97.2504 44.1054 103.009 49.414 107.69L53.8285 101.07C53.8285 101.07 56.9827 100.162 57.6616 98.9401C59.7917 95.1092 56.0107 88.4375 56.0107 88.4375C55.9328 86.839 55.6777 85.2541 55.25 83.7119C54.6823 82.2926 50.7083 80.3488 50.7083 80.3488C50.7083 80.3488 46.8752 74.104 46.8752 70.2708C46.8089 68.7677 47.338 67.299 48.3477 66.1835C49.3573 65.068 50.7661 64.3956 52.2684 64.3122C53.5361 64.0437 54.7338 63.5137 55.7848 62.7559C56.8359 61.9981 57.7172 61.0292 58.3724 59.9113C58.3724 59.9113 63.1979 58.6328 64.3333 56.6458C65.4688 54.6588 63.0571 47.5761 63.0571 47.5761C63.5035 45.7035 63.4871 43.7503 63.0095 41.8854C62.2182 40.161 60.9851 38.6764 59.4352 37.5822C58.1877 34.4701 56.2919 31.6593 53.8739 29.3368C47.2841 33.9371 41.9032 40.0614 38.189 47.1884C34.4749 54.3153 32.5375 62.2341 32.5417 70.2708Z",
				fill: "#8DE1CF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M120.539 69.6259C121.674 72.3237 118.406 79.2088 115.713 80.5532C112.956 81.8046 110.553 83.721 108.719 86.1303C107.724 87.6927 106.419 94.1328 103.155 95.4112C99.8923 96.6897 92.1533 103.972 88.0386 102.837C83.9238 101.701 83.9215 91.9073 86.7601 87.5065C88.4541 84.8791 86.4762 79.1316 86.3332 77.1469C86.1901 75.1622 80.2292 71.4698 80.2292 69.4829C80.2292 66.3605 87.0417 58.1287 87.0417 58.1287C89.3827 57.2844 91.8398 56.8057 94.3265 56.7094C96.0479 57.3361 97.6975 58.1445 99.2474 59.121C102.249 59.3455 105.208 59.9655 108.047 60.965L111.312 63.9443C111.312 63.9443 119.403 66.9282 120.539 69.6259Z",
				fill: "#8DE1CF"
			}),
			/* @__PURE__ */ _jsx("g", {
				filter: "url(#filter1_d_25_770)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M100.667 15.7708C95.2463 15.7708 90.0479 17.9241 86.2152 21.7568C82.3824 25.5896 80.2292 30.788 80.2292 36.2083C80.2292 48.4004 95.7049 64.1396 99.722 68.0136C99.9758 68.2579 100.314 68.3943 100.667 68.3943C101.019 68.3943 101.357 68.2579 101.611 68.0136C105.628 64.1396 121.104 48.4004 121.104 36.2083C121.104 30.788 118.951 25.5896 115.118 21.7568C111.285 17.9241 106.087 15.7708 100.667 15.7708Z",
					fill: "#FF5E84"
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M100.667 43.0208C104.429 43.0208 107.479 39.9708 107.479 36.2083C107.479 32.4459 104.429 29.3958 100.667 29.3958C96.9042 29.3958 93.8542 32.4459 93.8542 36.2083C93.8542 39.9708 96.9042 43.0208 100.667 43.0208Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
		id: "filter0_d_25_770",
		x: 26.5417,
		y: 9.77083,
		width: 115.917,
		height: 120.458,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 2,
				dy: 2
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_25_770"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_25_770",
				result: "shape"
			})
		]
	}), /* @__PURE__ */ _jsxs("filter", {
		id: "filter1_d_25_770",
		x: 74.2292,
		y: 9.77083,
		width: 56.875,
		height: 68.6234,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 2,
				dy: 2
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_25_770"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_25_770",
				result: "shape"
			})
		]
	})] })]
});
const ForwardRef = forwardRef(SvgWorldPin);
export default ForwardRef;
